import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Alcance } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class AlcanceService {

  private readonly service = '/sepin-backend/rest/alcances';

  private alcanceObservable: Observable<Alcance[]>;

  constructor(private readonly http: McticHttpClient) {
  }

  obterTodos() {
    if (!this.alcanceObservable) {
      this.alcanceObservable = this.http.get<Alcance[]>(this.service).pipe(publishReplay(1), refCount());
    }

    return this.alcanceObservable;
  }
}
